import React from 'react';
import { Hero } from '../components/landing/Hero';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { WhatIncluded } from '../components/landing/WhatIncluded';
import { WhatItsNot } from '../components/landing/WhatItsNot';
import { WhoItsFor } from '../components/landing/WhoItsFor';
import { Expectations } from '../components/landing/Expectations';
import { PricingCTA } from '../components/landing/PricingCTA';
import { FinalClose } from '../components/landing/FinalClose';
import { Footer } from '../components/landing/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  // Initialize Meta Pixel and track PageView on mount
  useMetaPixel();
  return <main className="min-h-screen bg-[#0f1419] text-[#f5f0e8] selection:bg-[#d4af37] selection:text-[#0f1419]" data-id="element-221">
      <Hero data-id="element-222" />
      <ProblemSection data-id="element-223" />
      <SolutionSection data-id="element-224" />
      <WhatIncluded data-id="element-225" />
      <WhatItsNot data-id="element-226" />
      <WhoItsFor data-id="element-227" />
      <Expectations data-id="element-228" />
      <PricingCTA data-id="element-229" />
      <FinalClose data-id="element-230" />
      <Footer data-id="element-231" />
    </main>;
}